import { Refine } from "@pankod/refine-core";
import { KBarProvider } from "@pankod/refine-kbar";
import {
    ErrorComponent,
    notificationProvider,
    Layout,
    GlobalStyles,
    CssBaseline,
    RefineSnackbarProvider,
} from "@pankod/refine-mui";
import { LoginPage } from "./pages/auth";
import routerProvider from "@pankod/refine-react-router-v6";
import { useTranslation } from "react-i18next";
import { FeaturedVideo } from "@mui/icons-material";

import {firebaseAuth, firestoreDatabase } from "./services/firebaseService";
import { FrameList, FrameCreate, FrameEdit } from "pages/frames";
import { ColorModeContextProvider } from "contexts";
import { Header, Title, Footer, Sider } from "components";

const App: React.FC = () => {
    const { t, i18n } = useTranslation();
    const i18nProvider = {
        translate: (key: string, params: object) => t(key, params),
        changeLocale: (lang: string) => i18n.changeLanguage(lang),
        getLocale: () => i18n.language,
    };

    return (
            <KBarProvider>
                <ColorModeContextProvider>
                    <CssBaseline />
                    <GlobalStyles
                        styles={{ html: { WebkitFontSmoothing: "auto" } }}
                    />
                    <RefineSnackbarProvider>
                        <Refine
                            routerProvider={{
                                ...routerProvider,
                            }}
                            dataProvider={firestoreDatabase.getDataProvider()}
                            authProvider={firebaseAuth.getAuthProvider()}
                            i18nProvider={i18nProvider}
                            Title={Title}
                            Sider={Sider}
                            ReadyPage={LoginPage}
                            Layout={Layout}
                            Header={Header}
                            Footer={Footer}
                            LoginPage={LoginPage}
                            catchAll={<ErrorComponent />}
                            options={{
                                syncWithLocation: true,
                                warnWhenUnsavedChanges: true,
                            }}
                            notificationProvider={notificationProvider}
                            resources={[
                                {   
                                    name: "Frames",
                                    list: FrameList,
                                    icon: <FeaturedVideo />,
                                    create: FrameCreate,
                                    edit: FrameEdit, 
                                    options: {
                                        label: "Frames"
                                    }
                                }
                            ]}
                        />
                    </RefineSnackbarProvider>
                </ColorModeContextProvider>
            </KBarProvider>
    );
};

export default App;
